module.exports = __webpack_public_path__ + "img/ico-rect-violet.c25e9eb9.svg";